<template>
    <div ref="login" class="login">
        <div class="logo-left-top" v-if="getTenantLogo() != null"
             :style="{ background: `url(${getTenantLogo()}) center / 150px no-repeat` }"></div>
        <div class="logo-middle-and" v-if="getTenantLogo() != null">×</div>
        <div class="logo-right-top"></div>
        <div class="left-area">
            <div class="title">
                EMIS V5.0
                <div class="sub-title">
                    <span v-for="(n, i) in $d('构建万物互联的智能工厂')" :key="i">{{ n }}</span>
                </div>
            </div>
            <div class="form">
                <div class="input-area">
                    <div class="el-icon-office-building">{{ $d('租户') }}</div>
                    <el-select v-model="form.tenant" filterable style="margin: 0 0 0px 0;"
                               :placeholder="$d('请选择')+$d('租户')">
                        <el-option
                            v-for="item in tenantList"
                            :key="item.id"
                            :label="item.tenantName"
                            :value="item.tenantId">
                        </el-option>
                    </el-select>
                    <!--                    <input v-model="form.tenant" :placeholder="$d('请输入') + $d('租户')"-->
                    <!--                           type="text">-->
                    <div class="el-icon-user">{{ $d('用户名') }}:</div>
                    <input v-model="form.account" :placeholder="$d('请输入你的用户名')" type="text">
                    <div class="el-icon-key">{{ $d('密码') }}:</div>
                    <input v-model="form.password" :placeholder="$d('请输入密码')" @keyup.enter="login" type="password">
                </div>
                <div :class="{ loading: loading }" type="primary" class="button" @click="login">
                    <div v-if="loading" class="loading-icon"></div>
                    <div v-else>{{ $d('登录') }}</div>
                </div>
                <div class="other-login">
                    <div class="divider">
                        <span>{{ $d('其他登录方式') }}</span>
                    </div>
                    <div class="login-options">
                        <div class="sso-login" @click="ssoLogin" v-if="config.ssoUrl">
                            <i class="el-icon-connection"></i>
                            <span>{{ $d('单点登录') }}</span>
                        </div>
                        <div class="oauth-login" @click="showOAuthDialog"
                             v-if="config.oauthProviders && config.oauthProviders.length > 0">
                            <i class="el-icon-share"></i>
                            <span>{{ $d('第三方登录') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="background" class="background"></div>
        <div ref="elem1" class="elem1"></div>
        <div ref="elem2" class="elem2"></div>
        <!--<div class="etaoIT">
            <a href="http://www.etao-it.com" target="_blank">400-606-2838</a>
        </div>-->

        <!-- 第三方登录弹窗 -->
        <el-dialog
            :title="$d('第三方登录')"
            :visible.sync="oauthDialogVisible"
            width="400px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="true"
            :modal-append-to-body="false"
            custom-class="oauth-dialog">
            <div class="oauth-providers">
                <div v-for="provider in config.oauthProviders"
                     :key="provider.name"
                     class="oauth-provider"
                     @click="handleOAuthLogin(provider)">
                    <i :class="provider.icon"></i>
                    <span>{{ provider.name }}</span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="oauthDialogVisible = false">{{ $d('取消') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {getTopUrl, TENANT_KEY} from '@/components/login/secret'
import {encrypt} from '@/utils/sm2'

export default {
    name: 'login',
    watch: {
        'form.tenant' (val) {
            localStorage.setItem(TENANT_KEY, val)
            console.log(val)
        }
    },
    methods: {
        login: function () {
            let data = this.form
            if (this.loading === false) {
                this.loading = true
                this.etao.requests.post({
                    url: '/etao-auth/oauth/token',
                    prototype: 'FormData',
                    data: {
                        grant_type: 'password',
                        username: data['account'],
                        password: encrypt(data['password'])
                    },
                    sendToken: false,
                    successMessage: false,
                    success: res => {
                        if (Object.keys(res).indexOf('success') >= 0 && !res.success) {
                            this.etao.message.toast(res.error_description, 'error')
                            return
                        }
                        let userInfoObj = this.etao.common.getData('userInfo')
                        if (userInfoObj === undefined || (userInfoObj.loginName !== res['account'])) {
                            // this.$store.getters['etao/pages'] = []
                            this.$store.state['etao/pages'] = []
                        }
                        this.etao.common.saveData('userInfo', {
                            realName: res['real_name'],
                            loginName: res['account'],
                            userId: res['user_id'],
                            name: res['nick_name']
                        })
                        let tenant = this.tenantList.find(item => item.tenantId === this.form.tenant)
                        this.etao.common.saveData('tenantInfo', {
                            tenantId: tenant['tenantId'],
                            tenantName: tenant['tenantName'],
                            logoUrl: tenant['logoUrl']
                        })
                        this.etao.common.setToken(res['access_token'])
                        this.etao.common.setToken(res['refresh_token'], 'r')
                        // 校验密码
                        const flag = this.checkPasswordRule(data['password'])
                        this.$router.push({
                            path: '/index',
                            query: {
                                passwordValid: flag
                            }
                        })
                    },
                    complete: () => {
                        this.loading = false
                    }
                })
            }
        },
        checkPasswordRule: function (password) {
            return /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}/.test(password)
        },
        getTenant () {
            let domain = getTopUrl()
            // 临时指定域名，方便测试
            // domain = "http://127.0.0.1";
            localStorage.removeItem(TENANT_KEY)
            this.etao.requests.get({
                url: '/etao-system/tenant/info',
                prototype: 'FormData',
                data: {
                    domain: domain
                },
                sendToken: false,
                successMessage: false,
                success: res => {
                    if (res.success && res.data.tenantId) {
                        this.form.tenantId = res.data.tenantId
                        localStorage.setItem(TENANT_KEY, res.data.tenantId)
                    } else {
                        this.etao.message.error('未配置域名信息，无法登录，请先配置域名信息')
                    }
                }
            })
        },
        loadTenantList () {
            this.etao.requests.get({
                url: '/etao-system/tenant/select-all',
                prototype: 'FormData',
                sendToken: false,
                successMessage: false,
                success: res => {
                    if (res.success && res.data.length > 0) {
                        this.$set(this, 'tenantList', res.data)
                    }
                }
            })
        },
        getTenantLogo () {
            let tenant = this.tenantList.find(item => item.tenantId === this.form.tenant)
            return tenant ? tenant.logoUrl : null
        },
        ssoLogin () {
            if (this.config.ssoUrl) {
                // 生成 state 参数用于防止 CSRF 攻击
                // const state = this.generateState()
                // localStorage.setItem('oauth_state', state)

                // 获取当前选中的租户信息
                const tenant = this.tenantList.find(item => item.tenantId === this.form.tenant)
                if (!tenant) {
                    this.etao.message.toast(this.$d('请先选择租户'), 'error')
                    return
                }

                // 保存租户信息，供回调时使用
                this.etao.common.saveData('tenantInfo', {
                    tenantId: tenant['tenantId'],
                    tenantName: tenant['tenantName'],
                    logoUrl: tenant['logoUrl']
                })

                // 构建完整的 SSO URL
                const baseUrl = this.config.ssoUrl.split('?')[0]
                const params = new URLSearchParams({
                    client_id: 'etao',
                    response_type: 'code',
                    redirect_uri: window.config.redirectUri,
                    // state: state,
                    tenant_id: tenant.tenantId
                })

                // 重定向到 SSO 登录页面
                window.location.href = `${baseUrl}?${params.toString()}`
            }
        },
        showOAuthDialog () {
            this.oauthDialogVisible = true
        },
        handleOAuthLogin (provider) {
            // 重定向到第三方登录页面
            const redirectUri = encodeURIComponent(window.config.redirectUri)
            const state = this.generateState()
            localStorage.setItem('oauth_state', state)
            window.location.href = `${provider.authUrl}?client_id=${provider.clientId}&redirect_uri=${redirectUri}&response_type=code&state=${state}`
        },
        generateState () {
            return Math.random().toString(36).substring(7)
        }
    },
    data () {
        return {
            form: {
                tenant: '',
                account: '',
                password: '',
                remember: false
            },
            loading: false,
            tenantList: [],
            oauthDialogVisible: false,
            config: {
                ssoUrl: window.config.ssoUrl,
                oauthProviders: window.config.oauthProviders || []
            }
        }
    },
    created () {
        // this.getTenant()

    },
    mounted () {
        this.loadTenantList()
        this.$store.commit('etao/removeAllPages')
        this.etao.common.removeData('navLog')
        if (localStorage.getItem(TENANT_KEY)) {
            this.form.tenant = localStorage.getItem(TENANT_KEY)
        }
    }
}
</script>

<style scoped src="./css/login.css"></style>



// WEBPACK FOOTER //
// src/components/login/login.vue